'use strict';

var processInclude = require('base/util');
var breakpoints = require('brand_core/components/breakpoints');

function scrollToVariations() {
    $('.pdp-sticky-btn .add-to-cart').on('click', function () {
        var variantOffset = $('.product-detail .attributes').offset().top;
        var headerHeight = $('header').outerHeight();

        $('html, body').scrollTop(variantOffset - headerHeight);
    });
}
$(function () {
    processInclude(require('./product/detail'));

    if (breakpoints.isMobileView()) {
        $(window).scroll(function () {
            scrollToVariations();
        });
    }
});
